export default __webpack_public_path__ + "static/media/sessions.86f72c2b.svg";